<template>
    <div class="banner_container bg_white box_shadow bottom" v-if="consultancy.detail">
        <div class="image_container">
            <span v-if="consultancy.detail.cover_photo" > 
                <img :src="consultancy.detail.cover_photo" alt="banner">
            </span>
            <span v-else><img src="@/assets/BANNER.png" alt="banner"></span>
        </div>
        <div class="logo_container">
            <div class="consultancy_logo">
                <span v-if="consultancy.logo" > <img :src="consultancy.logo" alt="banner" class="consultancy_img"></span>
                <span v-else> <img src="@/assets/LOGO.png" alt="banner" class="consultancy_img"></span>
            </div>
            <div class="logo_info" v-if="consultancy">
                <h2>{{ consultancy.client_name }}</h2>
                <h5><v-icon class="icon_size">location_on</v-icon>{{consultancy.detail.location}}</h5>
                <h5><v-icon class="icon_size">phone</v-icon>{{consultancy.detail.phone}}</h5>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['consultancy'])
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ConsultancyProfile/_header.vue